import styled from 'styled-components';

export const ActivityAlertText = styled.p`
  margin: 0 0 0 0;
`;

export const TextLink = styled.a`
  cursor: pointer;
`;
